// extracted by mini-css-extract-plugin
export default {"group":"subscription-group_group__aFuLZ","heading":"subscription-group_heading__n8I0i","subscriptionItems":"subscription-group_subscriptionItems__S1PZO"};